import classes from "./Article.module.css";
import Card from "../UI/Card";
import { useContext } from "react";
import ProjectInfoContext from "../../store/projectInfo-context";

const ProjectInfo = (props) => {
  const ctx = useContext(ProjectInfoContext);

  return (
    <Card>
      <div>
        <h1 className={`${classes.header} ${classes.center}`}>Project Info</h1>
        <p className={`${classes.text} ${classes.textHighlight}`}>02-09-2019</p>
        <div className={classes.images}>
          <p className={classes.text}>{ctx.info.pl}</p>
          <article>
            <img className={classes.image} src={ctx.photos[0]} alt="" />
            <p className={classes.textHighlight}>Logo Projektu</p>
            <p className={classes.textHighlight}>Project Logo</p>
          </article>
        </div>
        <p className={classes.text}>{ctx.info.en}</p>
      </div>
      <p className={`${classes.text} ${classes.textHighlight}`}>10-10-2019</p>
      <div className={classes.images}>
        <div className={classes.images}>
          <article>
            <img className={classes.image} src={ctx.photos[1]} alt="" />
            <p className={classes.textHighlight}>
              Zespół Erasmusa - nauczyciele
            </p>
            <p className={classes.textHighlight}>Erasmus Team - teachers</p>
          </article>
        </div>
        <div className={classes.images}>
          <article>
            <img className={classes.image} src={ctx.photos[2]} alt="" />
            <p className={classes.textHighlight}>
              Zespół Erasmusa - nauczyciele
            </p>
            <p className={classes.textHighlight}>Erasmus Team - teachers</p>
          </article>
        </div>
      </div>
      <p className={`${classes.text} ${classes.textHighlight}`}>
        04-09-2021 - 07-09-2021
      </p>
      <div className={classes.text}>{ctx.third.pl.text}</div>
      <div className={classes.images}>
        <article>
          <img className={classes.image} src={ctx.third.img[0]} alt="" />
        </article>
        <article>
          <img className={classes.image} src={ctx.third.img[1]} alt="" />
        </article>
      </div>
    </Card>
  );
};

export default ProjectInfo;
